import { render, staticRenderFns } from "./RecipeComments.vue?vue&type=template&id=495fc516&scoped=true"
import script from "./RecipeComments.vue?vue&type=script&lang=js"
export * from "./RecipeComments.vue?vue&type=script&lang=js"
import style0 from "./RecipeComments.vue?vue&type=style&index=0&id=495fc516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495fc516",
  null
  
)

export default component.exports